import { render, staticRenderFns } from "./querycustomeruseproducts.vue?vue&type=template&id=0fcb45a9"
import script from "./querycustomeruseproducts.vue?vue&type=script&lang=js"
export * from "./querycustomeruseproducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports